<template>
<div>
    <v-card class="mb-4">
        <v-toolbar class="info" dark flat dense cad>
            <v-toolbar-title class="subheading">Questions</v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>

        <v-card-text>
            <v-subheader v-if="formItems == null || formItems.length === 0">
                No questions have been added
            </v-subheader>
            <draggable v-else v-model="formItems" @start="drag=true" @end="drag=false" ghost-class="ghost" handle=".handle">
                <transition-group>
                    <div v-for="(item, index) in formItems" :key="index" class="item-row">
                        <table class="item-row-table">
                            <tr>
                                <td>
                                    <v-icon class="handle" title="Move">mdi-format-align-justify</v-icon>
                                </td>
                                <td>
                                    <v-hover>
                                        <div class="item" slot-scope="{ hover }" @click="onEditItemClick(item)">
                                            <table class="item-table">
                                                <tr>
                                                    <td>
                                                        {{item.question}}

                                                        <span style="display: block;" v-if="item.rankType == 1" class="check-in-answer-type">
                                                            <v-icon class="tl-red">mdi-circle</v-icon>
                                                            <v-icon class="tl-amber">mdi-circle</v-icon>
                                                            <v-icon class="tl-green">mdi-circle</v-icon>
                                                        </span>
                                                        <span style="display: block;" v-else-if="item.rankType == 2">
                                                            <v-tooltip bottom>
                                                                <span class="check-in-answer-type" slot="activator">
                                                                    <v-icon size="32" class="very-sad">mood_bad</v-icon>
                                                                    <v-icon size="32" class="sad">mdi-emoticon-sad-outline</v-icon>
                                                                    <v-icon size="32" class="neutral">mdi-emoticon-neutral-outline</v-icon>
                                                                    <v-icon size="32" class="happy">mdi-emoticon-happy-outline</v-icon>
                                                                    <v-icon size="32" class="very-happy">mood</v-icon>
                                                                </span>
                                                                <span>This question will be answered using a Happiness Scale</span>
                                                            </v-tooltip>
                                                        </span>
                                                    </td>
                                                    <td style="width: 100px;">
                                                        <v-btn v-show="hover" small class="error remove-btn" @click.stop="onRemoveItemClick(item)">Remove</v-btn>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </v-hover>
                                </td>
                            </tr>
                        </table>
                    </div>
                </transition-group>
            </draggable>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat small @click="onAddItemClick">
                <v-icon left>add</v-icon>Add Question </v-btn>
        </v-card-actions>
    </v-card>

    <check-in-item-editor  
        v-if="itemEditorDialog"
        :dialog="itemEditorDialog" 
        :title="itemEditorTitle" 
        :item="editedItem"
        @save="saveItem" 
        @closeEditor="itemEditorDialog = false" />

    </div>

</template>

<script>
    import draggable from 'vuedraggable';
    import CheckInItemEditor from '@/components/checkin/CheckInItemEditor';
    
    export default {
    	props: {
    		items: {
    			type: Array,
    			required: true
    		}
    	},
    	components: {
            draggable,
            CheckInItemEditor
    	},
    	data() {
    		return {
                itemEditorDialog: false,
                editedItem: null,
                formItems: this.items
            };
        },
        watch: {
            formItems() {
                this.$emit('onItemsUpdated', this.formItems);
            }
        },
        computed: {
            itemEditorTitle() {
				return this.editedItem != null ? 'New Question' : 'Edit Question';
			},
        },
    	methods: {
            saveItem(item) {
                if (this.editedItem != null) {
                    const index = this.formItems.findIndex(x=> x.id === item.id);
                    this.formItems[index] = item;
				} else {
					this.formItems.push(item);
				}
            },
            onEditItemClick(item) {
				this.editedItem = Object.assign({}, item);
				this.itemEditorDialog = true;
			},
    		onRemoveItemClick(item) {
                const index = this.formItems.indexOf(item);
                confirm('Are you sure you want to remove this question?') && this.formItems.splice(index, 1);
            },
            onAddItemClick() {
				this.editedItem = undefined;
				this.itemEditorDialog = true;
            }
    	}
    };
</script>

<style scoped>
    table {
    	width: 100%;
    }
    .item-row .item-row-table > tr > td:first-child {
    	width: 1px;
    	vertical-align: top;
    	padding-right: 8px;
    	cursor: move;
    }
    .item-row .item-row-table > tr > td:nth-child(2) {
    	width: 100%;
    }
    .item {
    	padding-top: 8px;
    	padding-bottom: 8px;
    	padding-left: 4px;
    	padding-right: 4px;
    }
    .item:hover {
    	background-color: rgba(0, 0, 0, 0.04);
    	cursor: pointer;
    }
    .item-table tr {
    	height: 28px;
    }
    .remove-btn {
    	margin-top: 0;
    	margin-bottom: 0;
    }

    .check-in-answer-type > i {
    	font-size: 1.4em;
    }

    .left-text {
    	text-align: left;
    }

    .icon {
    	display: inline-block;
    	font-size: 1.4em;
    	border-radius: 10px;
    	margin-right: 2px;
    }

    i.very-happy {
    	color: rgb(92, 182, 36);
    }

    i.happy {
    	color: rgb(170, 195, 32);
    }

    i.neutral {
    	color: rgb(244, 197, 17);
    }

    .handle {
        margin-top: 10px;
    }

    .ghost {
    	opacity: 0.5;
    	background: #c8ebfb;
    }

    i.sad {
    	color: rgb(246, 142, 31);
    }

    i.very-sad {
    	color: rgb(245, 77, 28);
    }

    .tl-red {
    	color: #f44336 !important;
    }

    .tl-amber {
    	color: #ffc107 !important;
    }

    .tl-green {
    	color: #4caf50 !important;
    }
</style>
